import { Dialogs } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import { Context } from '@leverege/plugin';
import { DataSources, Attributes } from '@leverege/ui-attributes';
import { GlobalState } from '@leverege/ui-redux';
import UpdateItem from "../views/updateItem/UpdateItem.js";
import { Names, Types } from "../constants/index.js";
const {
  tIcon
} = I18N.ns('api-ui-fota-management.UpdateAction');

// given a Relationship instance, make an update action that can be installed into molten
export default {
  id: 'blueprint.action.fota.UpdateItem',
  name: 'Update Fota Item',
  layout: {
    sort: 'item.update'
  },
  matches: [{
    // client : [ null, 'GroupScreen' ],
    use: ['contextMenu', 'mobileActionBar'],
    objectType: Types.updateable
  }, {
    client: ['MapBoxRolloverSelectionPointer', 'ListDataViewer'],
    use: ['contextMenu', 'mobileActionBar'],
    objectType: Types.updateable
  }],
  isPrepared: cxt => {
    const {
      clientProps: {
        objectType
      }
    } = cxt;
    const target = Context.getTargetOfType(cxt, objectType);
    if (!target) {
      // nothing to do
      return true;
    }
    const delegate = DataSources.getDelegate(target);
    return delegate.canUpdate() != null;
  },
  prepare: cxt => {
    const {
      clientProps: {
        objectType
      }
    } = cxt;
    const target = Context.getTargetOfType(cxt, objectType);
    const delegate = DataSources.getDelegate(target);
    return GlobalState.dispatch(delegate.requestCanUpdate());
  },
  handles: cxt => {
    const {
      clientProps: {
        objectType
      }
    } = cxt;
    const target = Context.getTargetOfType(cxt, objectType);
    if (!target) {
      return false;
    }
    const delegate = DataSources.getDelegate(target);
    return delegate.canUpdate();
  },
  appearance: ({
    context
  }) => {
    const {
      clientProps: {
        objectType
      }
    } = context;
    const target = Context.getTargetOfType(context, objectType);
    const name = Attributes.get('name', objectType, target?.data);
    return {
      name: `Update ${name || Names[objectType]}`,
      icon: tIcon('icon')
    };
  },
  perform: ({
    context
  }) => {
    const {
      reloadData,
      clientProps: {
        relationship,
        objectType
      }
    } = context;
    const target = Context.getTargetOfType(context, objectType);
    const delegate = DataSources.getDelegate(target);
    Dialogs.show({
      component: UpdateItem,
      props: {
        reloadData,
        objectType,
        relationship,
        target,
        delegate
      }
    });
  }
};